// src/pages/settings/BillingAddress.js
import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import API_BASE_URL from "../../config";
import { Link } from "react-router-dom";
import Select from "react-select";
import statesWithCities from "../../data/statesWithCities";

const BillingAddress = () => {
  const [form, setForm] = useState({
    company_name: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    pan: "",
    gst: "",
    cin: "",
    mobile: "",
    email: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [brandColor, setBrandColor] = useState("#f26722"); // default fallback


useEffect(() => {
  document.title = "Billing Address | Webyappy";
  fetchBillingAddress(); // ✅ Fetch data on component mount
}, []);

  const fetchBillingAddress = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/invoicing/get_billing_address`, {
        credentials: "include",
      });
      const data = await res.json();
      if (data?.status === "success" && data?.billing_address) {
        setForm(data.billing_address);
      }
    } catch (err) {
      console.error("Error fetching billing address:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const res = await fetch(
        `${API_BASE_URL}/invoicing/save_billing_address`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
          credentials: "include",
        },
      );
      const data = await res.json();
      if (data.status === "success") {
        alert("Billing address saved successfully!");
      } else {
        alert("Failed to save billing address.");
      }
    } catch (err) {
      console.error("Error saving billing address:", err);
      alert("Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3 col-lg-9 mx-auto">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/pages/settings/Settings" className="text-muted">
                  Settings
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-dark font-weight-bold">
                  Billing Address
                </span>
              </li>
            </ul>
          </div>

          <div className="card card-custom shadow-sm mb-5">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom p-2">
                <h5 className="font-weight-boldest mb-0">
                    Billing Address
                </h5>
                <Link to="/pages/settings/Settings" className="btn btn-light">
                    <i className="fas fa-arrow-left fa-xs mr-1"></i> Back
                </Link>
            </div>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">Company Name</label>
                    <input
                      type="text"
                      name="company_name"
                      className="form-control"
                      value={form.company_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-8 mb-3">
                    <label className="small">Address</label>
                    <textarea
                      name="address"
                      className="form-control"
                      value={form.address}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">State</label>
                    <Select
                      className="basic-single shadow-sm"
                      classNamePrefix="select"
                      placeholder="Select State"
                      options={Object.keys(statesWithCities).map((state) => ({
                        label: state,
                        value: state,
                      }))}
                      value={
                        form.state
                          ? { label: form.state, value: form.state }
                          : null
                      }
                      onChange={(option) =>
                        setForm((prev) => ({
                          ...prev,
                          state: option?.value || "",
                          city: "",
                        }))
                      }
                      isClearable
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">City</label>
                    <Select
                      className="basic-single shadow-sm"
                      classNamePrefix="select"
                      placeholder={
                        form.state ? "Select City" : "Select state first"
                      }
                      options={
                        form.state
                          ? statesWithCities[form.state].map((city) => ({
                              label: city,
                              value: city,
                            }))
                          : []
                      }
                      value={
                        form.city
                          ? { label: form.city, value: form.city }
                          : null
                      }
                      onChange={(option) =>
                        setForm((prev) => ({
                          ...prev,
                          city: option?.value || "",
                        }))
                      }
                      isDisabled={!form.state}
                      isClearable
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">Pincode</label>
                    <input
                      type="text"
                      name="pincode"
                      className="form-control"
                      value={form.pincode}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">PAN</label>
                    <input
                      type="text"
                      name="pan"
                      className="form-control"
                      value={form.pan}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">GST</label>
                    <input
                      type="text"
                      name="gst"
                      className="form-control"
                      value={form.gst}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-4 mb-3">
                    <label className="small">CIN (Corporate Identity No.)</label>
                    <input
                        type="text"
                        name="cin"
                        className="form-control"
                        value={form.cin}
                        onChange={handleChange}
                    />
                    </div>

                  <div className="form-group col-md-4 mb-3">
                    <label className="small">Mobile</label>
                    <input
                      type="text"
                      name="mobile"
                      className="form-control"
                      value={form.mobile}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6 mb-3">
                    <label className="small">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary font-weight-bold px-5 w-100"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingAddress;
